var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isContentLoading,
          expression: "isContentLoading",
        },
      ],
      attrs: { block: _vm.isContentLoading },
    },
    [
      _vm.policyDetails.holder
        ? _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "基本信息", name: "information" } },
                [
                  _vm.getShowRenewTips
                    ? _c("el-alert", {
                        attrs: {
                          title: _vm.getShowRenewTips.renewTips,
                          type: _vm.getShowRenewTips.renewTipsType,
                        },
                      })
                    : _vm._e(),
                  _c(
                    "el-card",
                    { attrs: { header: "保单信息" } },
                    [
                      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                        _c("span", [_vm._v("保单信息")]),
                        _c(
                          "div",
                          { staticStyle: { float: "right" } },
                          [
                            _vm.isShowPdfPolicy
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      "font-size": "1em",
                                      color: "red",
                                      "margin-right": "10px",
                                    },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onShowPdfDialog(1)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t查看电子保单\n\t\t\t\t\t\t"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "font-size": "14px" },
                                attrs: {
                                  icon: "el-icon-refresh",
                                  type: "text",
                                },
                                on: { click: _vm.onRefresh },
                              },
                              [_vm._v("刷新")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 3 } }, [
                            _vm._v("险种名称："),
                          ]),
                          _c("el-col", { attrs: { span: 9 } }, [
                            _vm._v(_vm._s(_vm.policyDetails.productTitle)),
                          ]),
                          _c("el-col", { attrs: { span: 3 } }, [
                            _vm._v("保险公司："),
                          ]),
                          _c("el-col", { attrs: { span: 9 } }, [
                            _vm._v(_vm._s(_vm.policyDetails.insuranceCompany)),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 3 } }, [
                            _vm._v("保单号："),
                          ]),
                          _c(
                            "el-col",
                            {
                              staticClass: "red-bold u-font-16",
                              attrs: { span: 9 },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.policyDetails.policyNo || "----") +
                                  "\n\t\t\t\t\t\t"
                              ),
                              _vm.policyDetails.policyNo
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass: "u-m-l-10",
                                      attrs: { plain: "", type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onCopy(
                                            _vm.policyDetails.policyNo
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t复制\n\t\t\t\t\t\t"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 3 } }, [
                            _vm._v("保单状态："),
                          ]),
                          !_vm.renewFlag && !_vm.payFlag
                            ? _c(
                                "el-col",
                                { attrs: { span: 9 } },
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: { type: _vm.getPolicyStatus.type },
                                    },
                                    [_vm._v(_vm._s(_vm.getPolicyStatus.label))]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.renewFlag
                            ? _c("el-col", { attrs: { span: 9 } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.getPolicyStatus.type,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.getPolicyStatus.label)
                                        ),
                                      ]
                                    ),
                                    !_vm.viewOnly
                                      ? _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              "margin-left": "40px",
                                            },
                                            attrs: {
                                              loading: _vm.isShowLoading,
                                              type: "warning",
                                            },
                                            on: { click: _vm.handleRenew },
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t去续保\n\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm.payFlag
                            ? _c("el-col", { attrs: { span: 9 } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.getPolicyStatus.type,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.getPolicyStatus.label)
                                        ),
                                      ]
                                    ),
                                    !_vm.viewOnly
                                      ? _c("pay-btn", {
                                          staticStyle: {
                                            "margin-left": "40px",
                                          },
                                          attrs: {
                                            "pay-btn-data-temp":
                                              _vm.getOrderData,
                                          },
                                          on: {
                                            onPayOffLineSuccess:
                                              _vm.onPayOffLineSuccess,
                                            onToOfflinePay: _vm.onToOfflinePay,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 3 } }, [
                            _vm._v("保单期限："),
                          ]),
                          _c("el-col", { attrs: { span: 9 } }, [
                            _vm._v(
                              _vm._s(_vm.policyDetails.effectiveDate) +
                                " 至 " +
                                _vm._s(_vm.policyDetails.expiryDate)
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 3 } }, [
                            _vm._v("总保费："),
                          ]),
                          _c(
                            "el-col",
                            { attrs: { span: 9 } },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.policyDetails.totalMoney) +
                                  "元\n\t\t\t\t\t\t"
                              ),
                              _vm.isShowPdfInvoice
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        padding: "4px 0",
                                        "font-size": "1em",
                                        color: "red",
                                      },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onShowPdfDialog(3)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t查看电子发票\n\t\t\t\t\t\t"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.policyDetails.invoice
                        ? _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 3 } }, [
                                _vm._v("开票类型："),
                              ]),
                              _c("el-col", { attrs: { span: 9 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.policyDetails.invoice.type === 1
                                      ? "增值税专票"
                                      : "增值税普票"
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.envConfig.isBxXsm()
                        ? _c(
                            "div",
                            [
                              _vm.policyDetails.payNo
                                ? _c(
                                    "el-row",
                                    [
                                      _c("el-col", { attrs: { span: 3 } }, [
                                        _vm._v("通知单号："),
                                      ]),
                                      _c(
                                        "el-col",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            color: "red",
                                            "font-size": "16px",
                                          },
                                          attrs: { span: 9 },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.policyDetails.payNo) +
                                              "\n\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.policyDetails.applyNo
                                ? _c(
                                    "el-row",
                                    [
                                      _c("el-col", { attrs: { span: 3 } }, [
                                        _vm._v("投保单号："),
                                      ]),
                                      _c(
                                        "el-col",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            color: "red",
                                            "font-size": "16px",
                                          },
                                          attrs: { span: 9 },
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.policyDetails.applyNo
                                              ) +
                                              "\n\t\t\t\t\t\t"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.policyDetails && _vm.policyDetails.holder
                    ? _c(
                        "el-card",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.isContentLoading,
                              expression: "isContentLoading",
                            },
                          ],
                          attrs: { header: _vm.onGetDes[0] },
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 3 } }, [
                                _vm._v(_vm._s(_vm.onGetDes[1])),
                              ]),
                              _c(
                                "el-col",
                                { attrs: { span: 9 } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.policyDetails.holder.unitName
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "u-m-l-10",
                                      attrs: { plain: "", type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onCopy(
                                            _vm.policyDetails.holder.unitName
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t复制\n\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm.policyDetails.holder.legalPerson
                                ? _c("el-col", { attrs: { span: 3 } }, [
                                    _vm._v("联系人："),
                                  ])
                                : _vm._e(),
                              _vm.policyDetails.holder.legalPerson
                                ? _c("el-col", { attrs: { span: 9 } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.policyDetails.holder.legalPerson
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 3 } }, [
                                _vm._v(_vm._s(_vm.onGetDes[4])),
                              ]),
                              _c(
                                "el-col",
                                { attrs: { span: 9 } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.policyDetails.holder.unitCode
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "u-m-l-10",
                                      attrs: { plain: "", type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onCopy(
                                            _vm.policyDetails.holder.unitCode
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t复制\n\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c("el-col", { attrs: { span: 3 } }, [
                                _vm._v("手机号码："),
                              ]),
                              _c("el-col", { attrs: { span: 9 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.policyDetails.holder.legalPersonMobile
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 3 } }, [
                                _vm._v("经营地址："),
                              ]),
                              _c("el-col", { attrs: { span: 9 } }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.policyDetails.holder.areaInfo.province
                                    ) +
                                    _vm._s(
                                      _vm.policyDetails.holder.areaInfo.city
                                    ) +
                                    _vm._s(
                                      _vm.policyDetails.holder.areaInfo.district
                                    ) +
                                    _vm._s(
                                      _vm.policyDetails.holder.unitAddress
                                    ) +
                                    "\n\t\t\t\t\t"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._l(_vm.insuredList, function (insured, index) {
                    return _c(
                      "el-card",
                      { key: insured.unitId, attrs: { offset: 1 } },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "header" }, slot: "header" },
                          [
                            _vm.insuredList.length > 1
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.onGetDes[2]) + _vm._s(index + 1)
                                  ),
                                ])
                              : _c("span", [_vm._v(_vm._s(_vm.onGetDes[2]))]),
                          ]
                        ),
                        _c(
                          "el-row",
                          [
                            _c("el-col", { attrs: { span: 3 } }, [
                              _vm._v(_vm._s(_vm.onGetDes[3])),
                            ]),
                            _c(
                              "el-col",
                              { attrs: { span: 9 } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(insured.unitName) +
                                    "\n\t\t\t\t\t\t"
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "u-m-l-10",
                                    attrs: { plain: "", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onCopy(insured.unitName)
                                      },
                                    },
                                  },
                                  [_vm._v("复制")]
                                ),
                              ],
                              1
                            ),
                            insured.legalPerson
                              ? _c("el-col", { attrs: { span: 3 } }, [
                                  _vm._v("联系人："),
                                ])
                              : _vm._e(),
                            insured.legalPerson
                              ? _c("el-col", { attrs: { span: 9 } }, [
                                  _vm._v(_vm._s(insured.legalPerson)),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c("el-col", { attrs: { span: 3 } }, [
                              _vm._v(_vm._s(_vm.onGetDes[4])),
                            ]),
                            _c(
                              "el-col",
                              { attrs: { span: 9 } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(insured.unitCode) +
                                    "\n\t\t\t\t\t\t"
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "u-m-l-10",
                                    attrs: { plain: "", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onCopy(insured.unitCode)
                                      },
                                    },
                                  },
                                  [_vm._v("复制")]
                                ),
                              ],
                              1
                            ),
                            _c("el-col", { attrs: { span: 3 } }, [
                              _vm._v("手机号码："),
                            ]),
                            _c("el-col", { attrs: { span: 9 } }, [
                              _vm._v(_vm._s(insured.legalPersonMobile)),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c("el-col", { attrs: { span: 3 } }, [
                              _vm._v("经营地址："),
                            ]),
                            _c("el-col", { attrs: { span: 10 } }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(insured.areaInfo.province) +
                                  _vm._s(insured.areaInfo.city) +
                                  _vm._s(insured.areaInfo.district) +
                                  _vm._s(insured.unitAddress) +
                                  "\n\t\t\t\t\t"
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _vm.attachmentList.length > 0
                    ? _c(
                        "el-card",
                        { attrs: { offset: 1 } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "header" }, slot: "header" },
                            [_c("span", [_vm._v("附件")])]
                          ),
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { data: _vm.attachmentList, border: "" },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "name",
                                  label: "附件名称",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "file-name" },
                                            [_vm._v(_vm._s(row))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1419263584
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "操作",
                                  width: "120",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "small",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDownloadAttach(
                                                    row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("下载")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1194035799
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "保障人员", name: "employee" } },
                [
                  _c(
                    "el-row",
                    { attrs: { span: 24 } },
                    [
                      _c("el-col", { attrs: { md: 24, sm: 24, xs: 24 } }, [
                        this.insureType === 14
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "20px" } },
                              [
                                _c("avue-crud", {
                                  attrs: {
                                    data: _vm.employeeList,
                                    option: _vm.employeeOption,
                                    page: _vm.employeePage,
                                  },
                                  on: {
                                    "update:page": function ($event) {
                                      _vm.employeePage = $event
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _c("avue-crud", {
                                  ref: "crud_emp",
                                  attrs: {
                                    data: _vm.employeeList,
                                    option: _vm.employeeOption,
                                    page: _vm.employeePage,
                                    "table-loading": _vm.employeeLoading,
                                  },
                                  on: {
                                    "update:page": function ($event) {
                                      _vm.employeePage = $event
                                    },
                                    "search-change": _vm.employeeSearchChange,
                                    "refresh-change": _vm.employeeRefreshChange,
                                    "size-change": _vm.employeeSizeChange,
                                    "current-change": _vm.employeeCurrentChange,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "menuLeft",
                                        fn: function (ref) {
                                          var size = ref.size
                                          return !_vm.viewOnly
                                            ? [
                                                _vm.isShowAddButton
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          loading:
                                                            _vm.isShowLoading,
                                                          size: size,
                                                          icon: "el-icon-plus",
                                                          type: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleReplaceAdd()
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t增加保障人员\n\t\t\t\t\t\t\t\t"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.isShowReplaceMoreButton
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          loading:
                                                            _vm.isShowLoading,
                                                          size: size,
                                                          icon: "el-icon-sort",
                                                          type: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleReplaceMore(
                                                              0
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t批量替换人员\n\t\t\t\t\t\t\t\t"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.isShowRenameMoreButton
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          loading:
                                                            _vm.isShowLoading,
                                                          size: size,
                                                          icon: "el-icon-sort",
                                                          type: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleReplaceMore(
                                                              1
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t批量修改人员姓名\n\t\t\t\t\t\t\t\t"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            : undefined
                                        },
                                      },
                                      {
                                        key: "menuRight",
                                        fn: function () {
                                          return [
                                            _c("el-button", {
                                              staticClass:
                                                "el-icon-download-emp",
                                              attrs: {
                                                loading: _vm.isShowLoading,
                                                icon: "el-icon-download",
                                              },
                                              on: { click: _vm.onDownloadEmp },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "menu",
                                        fn: function (scope) {
                                          return !_vm.viewOnly
                                            ? [
                                                _vm.isShowReplaceButton
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          loading:
                                                            _vm.isShowLoading,
                                                          icon: "el-icon-sort",
                                                          type: "text",
                                                        },
                                                        nativeOn: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleReplaceSingle(
                                                              scope.row,
                                                              0
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t替换\n\t\t\t\t\t\t\t\t"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.isShowRenameButton
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          loading:
                                                            _vm.isShowLoading,
                                                          icon: "el-icon-sort",
                                                          type: "text",
                                                        },
                                                        nativeOn: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleReplaceSingle(
                                                              scope.row,
                                                              1
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t改名\n\t\t\t\t\t\t\t\t"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            : undefined
                                        },
                                      },
                                      {
                                        key: "empName",
                                        fn: function (scope) {
                                          return [
                                            scope.row.claimStatus == 1
                                              ? _c(
                                                  "span",
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          scope.row.empName
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                    scope.row.claimStatus == 1
                                                      ? _c(
                                                          "el-tag",
                                                          {
                                                            attrs: {
                                                              type: "danger",
                                                            },
                                                          },
                                                          [_vm._v("存在出险")]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(scope.row.empName)
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "insureMoney",
                                        fn: function (scope) {
                                          return [
                                            _vm._v(
                                              _vm._s(scope.row.insureMoney) +
                                                "万"
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              this.insureType != 14
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "批改记录", name: "endorsement" } },
                    [
                      _c(
                        "el-row",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { md: 24, sm: 24, xs: 24 } },
                            [
                              _vm.policyDetails &&
                              _vm.policyDetails.newProductid
                                ? _c("avue-crud", {
                                    ref: "crud_change",
                                    attrs: {
                                      "cell-style": _vm.endorsementCellStyle,
                                      data: _vm.tableData,
                                      option: _vm.endorsementOption,
                                      page: _vm.endorsementPage,
                                      "row-style": _vm.endorsementRowStyle,
                                      "table-loading": _vm.endorsementLoading,
                                    },
                                    on: {
                                      "update:page": function ($event) {
                                        _vm.endorsementPage = $event
                                      },
                                      "search-change":
                                        _vm.endorsementSearchChange,
                                      "refresh-change":
                                        _vm.endorsementRefreshChange,
                                      "size-change": _vm.endorsementSizeChange,
                                      "current-change":
                                        _vm.endorsementCurrentChange,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "menuLeft",
                                          fn: function (ref) {
                                            var size = ref.size
                                            return [
                                              _c(
                                                "el-radio-group",
                                                {
                                                  on: {
                                                    change:
                                                      _vm.endorsementTypeChange,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.endorsementSearchForm
                                                        .changeCode,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.endorsementSearchForm,
                                                        "changeCode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "endorsementSearchForm.changeCode",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-radio-button",
                                                    {
                                                      attrs: {
                                                        size: size,
                                                        label: "101",
                                                      },
                                                    },
                                                    [_vm._v("新增人员")]
                                                  ),
                                                  _c(
                                                    "el-radio-button",
                                                    {
                                                      attrs: {
                                                        size: size,
                                                        label: "102",
                                                      },
                                                    },
                                                    [_vm._v("替换人员")]
                                                  ),
                                                  _c(
                                                    "el-radio-button",
                                                    {
                                                      attrs: {
                                                        size: size,
                                                        label: "999",
                                                      },
                                                    },
                                                    [_vm._v("其他批改")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "menu",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _vm.endorsementSearchForm
                                                .changeCode == 101
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "u-flex-col u-col-center u-row-center",
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "u-flex u-row-center",
                                                        },
                                                        [
                                                          _c(
                                                            "el-button",
                                                            {
                                                              staticStyle: {
                                                                margin:
                                                                  "0 10px",
                                                              },
                                                              attrs: {
                                                                icon: "el-icon-view",
                                                                type: "text",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.handleViewEndorsement(
                                                                      row
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t查看\n\t\t\t\t\t\t\t\t\t"
                                                              ),
                                                            ]
                                                          ),
                                                          !_vm.viewOnly &&
                                                          row.status &&
                                                          row.status == 1
                                                            ? _c(
                                                                "el-button",
                                                                {
                                                                  staticStyle: {
                                                                    margin:
                                                                      "0 10px",
                                                                  },
                                                                  attrs: {
                                                                    icon: _vm.cancelStatusIcon,
                                                                    type: "text",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleCancelEndorsement(
                                                                          row
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t取消\n\t\t\t\t\t\t\t\t\t"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                      !_vm.viewOnly &&
                                                      row.status
                                                        ? _c(
                                                            "div",
                                                            [
                                                              row.status == 1
                                                                ? _c(
                                                                    "pay-btn",
                                                                    {
                                                                      attrs: {
                                                                        "pay-btn-data-temp":
                                                                          _vm.getItemOrderData(
                                                                            row
                                                                          ),
                                                                      },
                                                                      on: {
                                                                        onPayOffLineSuccess:
                                                                          _vm.onPayOffLineSuccess,
                                                                        onToOfflinePay:
                                                                          _vm.onToOfflinePay,
                                                                      },
                                                                    }
                                                                  )
                                                                : _vm._e(),
                                                              _vm.isShowAddButton &&
                                                              (row.status ===
                                                                8 ||
                                                                row.status ===
                                                                  4)
                                                                ? _c(
                                                                    "el-button",
                                                                    {
                                                                      attrs: {
                                                                        loading:
                                                                          _vm.isShowLoading,
                                                                        icon: "el-icon-edit",
                                                                        type: "text",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.isJudgeCenter(
                                                                              _vm
                                                                                .EnumInsureType
                                                                                .add,
                                                                              row.recordId
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t重新提交\n\t\t\t\t\t\t\t\t\t"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              row.status == 3 &&
                                                              _vm.isShowPdfPolicy
                                                                ? _c(
                                                                    "el-button",
                                                                    {
                                                                      attrs: {
                                                                        icon: "el-icon-view",
                                                                        type: "text",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.onShowPdfDialog(
                                                                              2,
                                                                              row
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n\t\t\t\t\t\t\t\t\t\t电子批单\n\t\t\t\t\t\t\t\t\t"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      row.status == 1 &&
                                                      _vm.isDownloadPayFile(
                                                        row.insureType
                                                      )
                                                        ? _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                loading:
                                                                  _vm.isShowLoading,
                                                                icon: "el-icon-download",
                                                                type: "text",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.onDownloadPayFile(
                                                                      row
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t下载缴费通知书\n\t\t\t\t\t\t\t\t"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                : _vm.endorsementSearchForm
                                                    .changeCode == 102
                                                ? [
                                                    row.status &&
                                                    row.status == 3 &&
                                                    _vm.isShowPdfPolicy
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              icon: "el-icon-view",
                                                              type: "text",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onShowPdfDialog(
                                                                  2,
                                                                  row
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t电子批单\n\t\t\t\t\t\t\t\t"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                : [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          icon: "el-icon-view",
                                                          type: "text",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleViewSurrender(
                                                              row
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("查看")]
                                                    ),
                                                    !_vm.viewOnly
                                                      ? [
                                                          row.btn &&
                                                          row.btn.submitMaterial
                                                            ? _c(
                                                                "el-button",
                                                                {
                                                                  attrs: {
                                                                    icon: "el-icon-upload",
                                                                    type: "text",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleSubmitMaterials(
                                                                          row
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t提交材料\n\t\t\t\t\t\t\t\t\t"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          row.btn &&
                                                          row.btn.addMaterial
                                                            ? _c(
                                                                "el-button",
                                                                {
                                                                  attrs: {
                                                                    icon: "el-icon-upload",
                                                                    type: "text",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleSupplementMaterials(
                                                                          row
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t补传材料\n\t\t\t\t\t\t\t\t\t"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          row.btn &&
                                                          row.btn.addExpressNo
                                                            ? _c(
                                                                "el-button",
                                                                {
                                                                  attrs: {
                                                                    icon: "el-icon-upload",
                                                                    type: "text",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleSubmitExpressNo(
                                                                          row
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n\t\t\t\t\t\t\t\t\t\t上传快递单号\n\t\t\t\t\t\t\t\t\t"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      : _vm._e(),
                                                    row.btn &&
                                                    row.btn.showEndorse
                                                      ? _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              icon: "el-icon-view",
                                                              type: "text",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.onShowPdfDialog(
                                                                  2,
                                                                  row
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t电子批单\n\t\t\t\t\t\t\t\t"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      177731199
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.endorsementDetailsDialogVisible,
            title: "新增人员明细",
            top: "25vh",
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.endorsementDetailsDialogVisible = $event
            },
          },
        },
        [
          _vm.endorsementDetails.length > 0
            ? _c("avue-crud", {
                ref: "crud",
                attrs: {
                  data: _vm.endorsementDetails,
                  option: _vm.endorsementDetailsOption,
                  "table-loading": _vm.tableLoading,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("product-choice", {
        attrs: {
          isShowProductChoiceTemp: _vm.isShowProductChoice,
          "product-list": _vm.productList,
        },
        on: {
          onClickClose: _vm.onClickClose,
          onClickInsure: _vm.onClickInsure,
        },
      }),
      _c("insure-notices", {
        ref: "refInsureNotices",
        on: { onToInsure: _vm.goToInsure, onToSure: _vm.goToInsure },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isShowQrCode,
            center: "",
            title: "微信扫一扫，有惊喜降临",
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowQrCode = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "u-flex u-row-center",
              staticStyle: { padding: "0 20px" },
            },
            [
              _c("img", {
                attrs: {
                  src: "data:image/png;base64," + _vm.qrCodeUrl,
                  alt: "",
                },
              }),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "u-flex u-row-center",
              staticStyle: { "margin-top": "30px" },
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.isShowLoading,
                    icon: "el-icon-refresh",
                    type: "primary",
                  },
                  on: { click: _vm.onRefreshCode },
                },
                [_vm._v("\n\t\t\t\t刷新小程序码\n\t\t\t")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("PayOffLineDialog", {
        ref: "refPayDialog",
        on: { onPayOffLineSuccess: _vm.onPayOffLineSuccess },
      }),
      _c("show-pdf-dialog", { ref: "refPdf" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }